import { create } from 'zustand';

export type Locale = 'sr' | 'en';

const KEY = 'dp-client-locale';

function load(): Locale {
  try {
    const v = localStorage.getItem(KEY);
    if (v === 'en' || v === 'sr') return v;
  } catch { /* ignore */ }
  return 'sr';
}

function applyLang(locale: Locale) {
  if (typeof document !== 'undefined') {
    document.documentElement.lang = locale;
  }
}

applyLang(load());

export const useLocaleStore = create<{
  locale: Locale;
  setLocale: (locale: Locale) => void;
}>((set) => ({
  locale: load(),
  setLocale(locale) {
    try { localStorage.setItem(KEY, locale); } catch { /* ignore */ }
    applyLang(locale);
    set({ locale });
  },
}));
